/** Paginas publicas do painel: login do operador e recuperacao de senha (spec 001, 4.7). */
import { ErroApi, TelaEntrarPainel, TelaEsqueciSenha, type RespostaDeEntrada } from "@mtc/ui";
import { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import { marca } from "../config";
import { useSessao } from "../sessao";

const SEM_CONEXAO = "Não foi possível falar com o servidor. Confira sua conexão e tente de novo.";
function mensagem(err: unknown, porStatus: Record<number, string>, reserva: string) {
  if (err instanceof ErroApi) return porStatus[err.status] ?? (err.status === 429 ? "Muitas tentativas. Espere um pouco e tente de novo." : reserva);
  return SEM_CONEXAO;
}

export function PaginaEntrar() {
  const { publica, entrou } = useSessao();
  const navegar = useNavigate();
  const [params] = useSearchParams();
  const aviso = (useLocation().state as { aviso?: string } | null)?.aviso;
  const [erro, setErro] = useState<string>();
  const [carregando, setCarregando] = useState(false);
  return (
    <TelaEntrarPainel
      marca={marca()}
      aviso={aviso}
      erro={erro}
      carregando={carregando}
      aoEnviar={async ({ email, senha }) => {
        setCarregando(true);
        setErro(undefined);
        try {
          await entrou(await publica<RespostaDeEntrada>("/v1/auth/admin/entrar", { email, senha }));
          const volta = params.get("volta");
          navegar(volta && volta.startsWith("/") && !volta.startsWith("//") ? volta : "/", { replace: true });
        } catch (err) {
          setErro(mensagem(err, { 401: "E-mail ou senha incorretos.", 400: "Confira o e-mail e a senha." }, "Não conseguimos entrar agora. Tente de novo."));
        } finally {
          setCarregando(false);
        }
      }}
    />
  );
}

export function PaginaEsqueciSenha() {
  const { publica } = useSessao();
  const navegar = useNavigate();
  const [etapa, setEtapa] = useState<"identificar" | "codigo">("identificar");
  const [email, setEmail] = useState("");
  const [erro, setErro] = useState<string>();
  const [carregando, setCarregando] = useState(false);
  const rodar = async (f: () => Promise<void>) => {
    setCarregando(true);
    setErro(undefined);
    try { await f(); } finally { setCarregando(false); }
  };
  return (
    <TelaEsqueciSenha
      marca={marca()}
      publico="painel"
      etapa={etapa}
      erro={erro}
      carregando={carregando}
      aoPedirCodigo={(id) => rodar(async () => {
        try {
          await publica("/v1/recuperacao/admin/senha", { email: id });
          setEmail(id);
          setEtapa("codigo");
        } catch (err) {
          setErro(mensagem(err, { 400: "Confira o e-mail." }, "Não conseguimos enviar o código agora. Tente de novo."));
        }
      })}
      aoConfirmar={({ codigo, novaSenha }) => rodar(async () => {
        try {
          await publica("/v1/recuperacao/admin/senha/confirmar", { email, codigo, nova_senha: novaSenha });
          navegar("/entrar", { replace: true, state: { aviso: "Senha alterada. Entre com a nova senha." } });
        } catch (err) {
          setErro(mensagem(err, { 400: "Código inválido, vencido ou já usado. Peça outro código." }, "Não conseguimos salvar a senha agora. Tente de novo."));
        }
      })}
      aoTrocarDado={() => { setEtapa("identificar"); setErro(undefined); }}
    />
  );
}
